import CtaLink2 from "@/ui/atoms/CtaLink2"
import { ReactNode } from "react"

export interface CustomFormCtaProps {
  onClick: () => void
  label: ReactNode
  loading?: boolean
}

const CustomFormCta = ({ onClick, label, loading }: CustomFormCtaProps) => {
  return (
    <CtaLink2
      onClick={onClick}
      loading={loading}
      label={label}
      variant="filled"
      color="primary"
      size="sm"
    />
  )
}

export default CustomFormCta
